import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Clock } from 'lucide-react';
import ContactForm from '@/components/site/ContactForm';
import { CONTACT } from '@/constants/testIds';

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <section
        id={CONTACT.section}
        data-testid={CONTACT.section}
        className="relative overflow-hidden bg-[#000919] text-white"
      >
        <div
          className="pointer-events-none absolute inset-0 opacity-55"
          style={{
            background:
              'radial-gradient(900px 500px at 85% 12%, rgba(138,1,230,0.18), transparent 60%), radial-gradient(700px 400px at 10% 95%, rgba(255,80,129,0.12), transparent 60%)',
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-20 md:pt-28 md:pb-28">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-[0.22em] text-[#FF5081]">
            Contact · Book a strategy call
          </p>
          <motion.h1
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mt-5 font-display text-[44px] sm:text-5xl lg:text-6xl xl:text-[64px] font-semibold tracking-[-0.025em] leading-[1.02] max-w-4xl"
          >
            Let’s hit your <span className="text-[#FF5081]">number.</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.08 }}
            className="mt-7 max-w-2xl text-base lg:text-lg text-white/65 leading-relaxed"
          >
            Tell us your goal. We’ll come back with a plan that puts your spend where it actually performs.
            One strategy call. No agency runaround.
          </motion.p>

          <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

            <aside className="lg:col-span-5 flex flex-col gap-4">
              <div className="rounded-2xl p-7 md:p-8 bg-white/[0.03] border border-white/10">
                <div className="grid grid-cols-1 gap-5">
                  <Info icon={Mail} label="Email" value={<a href="mailto:hello@sellrly.com" className="hover:text-[#FF5081]">hello@sellrly.com</a>} />
                  <Info icon={MapPin} label="Operating" value="Remote-first. US & EU coverage." />
                  <Info icon={Clock} label="Response time" value="Within one business day." />
                </div>
              </div>

              <div className="rounded-2xl p-7 md:p-8 bg-[#FF5081] text-white">
                <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-white/85">Featured result</p>
                <p className="mt-3 font-display text-3xl md:text-[34px] font-semibold tracking-[-0.02em] leading-none">
                  61% below target CPA
                </p>
                <p className="mt-3 text-white/85 text-[15px]">in 14 days — without an agency, without the wait.</p>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
}

function Info({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-4">
      <span className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-lg bg-[#FF5081]/10 text-[#FF5081] border border-[#FF5081]/20 flex-shrink-0">
        <Icon className="w-4 h-4" />
      </span>
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-white/50">{label}</p>
        <p className="mt-1 text-white text-[15px]">{value}</p>
      </div>
    </div>
  );
}
